module.exports = __webpack_public_path__ + "static/media/bitmap@2x.20fb7fa7.jpg";